<template>
    <div>
        <CRow><CCol tag="label" class="col-form-label">Временные слоты</CCol></CRow>
        <div>
            <CRow
                v-for="(slot, index) of slots"
                :key="index"
                class="d-flex justify-content-start pl-3 pr-3"
            >
                <CCol class="slot">
                    <CRow>
                        <CCol col="6">
                            <span>С</span>
                            <CInput
                                v-model="slot.start_at"
                                type="time"
                                :change="setSlots(slots)"
                            />
                        </CCol>
                        <CCol col="6">
                            <span>До</span>
                            <CInput
                                v-model="slot.end_at"
                                type="time"
                                :change="setSlots(slots)"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol col="6">
                            <span>Время доставки (чч:мм)</span>
                            <CInput
                                v-model="slot.deliveri_time"
                                type="text"
                                :change="setSlots(slots)"
                            />
                        </CCol>
                        <CCol v-if="slot.deliveri_time" col="6">
                            <span>Максимальное время доставки(чч:мм)</span>
                            <CInput
                                v-model="slot.max_delivery_time"
                                type="text"
                                :change="setSlots(slots)"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol col="6">
                            <span>День недели</span>
                            <CSelect
                                inline
                                :options="slotsOptions"
                                :value.sync="slot.day_of_week"
                                placeholder="Выберите день недели..."
                                :change="setSlots(slots)"
                            />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol col="6" class="">
                            <span>Только сегодня</span>
                            <CRow class="pt-1">
                                <CSwitch
                                    class="ml-5"
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="slot.temp"
                                />
                            </CRow>
                        </CCol>
                        <CCol col="6" class="d-flex align-items-center justify-content-center">
                            <CButton
                                shape="pill"
                                color="danger"
                                variant="ghost"
                                @click="removeSlot(index)"
                            >
                                <CIcon
                                    :height="24"
                                    :content="$options.icons.cilTrash"
                                    class="handle"
                                />
                                Удалить
                            </CButton>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CButton
                shape="pill"
                color="success"
                variant="ghost"
                @click="addSlot"
            >
                <CIcon
                    :height="24"
                    :content="$options.icons.cilPlus"
                    class="handle"
                />
                Добавить
            </CButton>
        </div>
    </div>
</template>

<script>
    import { cilPlus, cilTrash } from '@coreui/icons';
    import { DAYS_OF_THE_WEEK  } from '../utils/time-slots';
    export default {
        icons: {
            cilPlus,
            cilTrash
        },

        props: {
            timeSlots: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            slots: [],
            daysOfTheWeek: DAYS_OF_THE_WEEK,
        }),

        computed: {
            slotsOptions: function() {
                let countDay = 0;
                const slotsOptions = [];
                slotsOptions.push({
                    value: null,
                    label: 'Без дня недели',
                })
                this.daysOfTheWeek.forEach(day => {
                    slotsOptions.push({
                        value: countDay,
                        label: day
                    });
                    countDay += 1;
                });
                return slotsOptions;
            },
        },

        watch: {
            timeSlots: function() {
                this.setModel();
            }
        },

        created() {
            this.setModel();
        },

        methods: {
            setModel() {
                this.slots = this.timeSlots;
            },
            setSlots (slots) {
                this.$emit('set-timeSlots', slots);
            },
            setDayOfTheWeek(slot, event){
               slot.day_of_week = +event.target.value;
            },
            addSlot() {
                this.slots.push({
                    start_at: '13:00',
                    end_at: '14:00',
                    deliveri_time: '01:20',
                    max_delivery_time: '01:30',
                });
                this.$emit('set-timeSlots', this.slots);
            },
            removeSlot(ind) {
                this.slots.splice(ind, 1);
                this.$emit('set-timeSlots', this.slots);
            }
        },
    };
</script>
<style scoped>
.slot {
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    border: 2px solid;
    border-color: #d8dbe0;
    border-radius: 5px;
}
</style>
